'use client'
import { Dispatch, ReactNode, SetStateAction, useState } from 'react';
import {waxlogin,phantomLogin, linkLogin, getConnectUrl, backpackLogin } from "../lib/wallets.ts"
import { WCW , ANCHOR, PHANTOM, PHANTOMAPP, BlockchainInfos, BACKPACK, BC_WAX, BC_SOLANA } from '../lib/blockchainSession.ts';
import { resetwax } from '../lib/actionsWax.js';




  type NavBarWalletListProp = {
    blockchaininfos : BlockchainInfos;
    setBCInfos: Dispatch<SetStateAction<BlockchainInfos>>
  }
                            
  const NavBarWalletList = (props: NavBarWalletListProp):ReactNode =>{

    const solanaEndPT = props.blockchaininfos.solanaEndPT;
    const waxEndPT = props.blockchaininfos.waxEndPT;

    let noWebPhantom = false;
    let connectURL = '';

    const netType = props.blockchaininfos.testnet === true ? 1 : props.blockchaininfos.localnet === true? 2: 0;
    const bcType = props.blockchaininfos.network.startsWith('wax') ? BC_WAX:BC_SOLANA;
    const [network, setNetwork] = useState(netType);
    const [blockchain, setBlockchain] = useState(bcType);

    

    const networks = ['mainnet', 'testnet', 'localnet'];
    let phantom = null;
    
    if ('phantom' in window) {
      phantom = window.phantom ? window.phantom: null;
    }

    if(phantom === null){
      noWebPhantom = true;
      const snetworks = ['mainnet', 'devnet', 'localnet'];
      connectURL = getConnectUrl( props.blockchaininfos.sessID, props.blockchaininfos.phantomInfos, snetworks[network] )
    }

    

    //testnet<input type="checkbox" onChange = { ()=> netChange() } value="1" checked={props.blockchaininfos.testnet} />
    return (
          <div className='container-fluid' >
             <div className='row p-0 m-0' >

              <div className='col text-right' >
              
                {blockchain == BC_SOLANA ? (<img src="assets/img/solanaLogo.png" className='blockchain-logo' alt='solana'/>):(<img src="assets/img/wax-wallet-logo.png" className='blockchain-logo' alt='wax'/>)}
                <select id="blockchain-select" name="blockchain-select" defaultValue={blockchain} onChange = { (e)=> setBlockchain(parseInt(e.target.value)) }>
                  <option value={BC_WAX}>wax</option>
                  <option value={BC_SOLANA}>solana</option>
                </select>
                <select id="network-select" name="network-select" defaultValue={network} onChange = { (e)=> setNetwork(parseInt(e.target.value)) }>
                  <option value="0">mainnet</option>
                  <option value="1">testnet</option>
                  {blockchain === BC_SOLANA ?(<option value="2">localnet</option>):(<option></option>)}
                </select>
              </div>
            </div>
            <div className='row p-0 m-0' >
              {blockchain == BC_SOLANA ? (
                <div className='col p-0 m-0'>
                  {network != 2 ?
                    (
                      <div>
                      { noWebPhantom === true ?
                        (<link
                          id='phantom-wallet' 
                          className='btn-sm btn-primary login-btn' 
                          href={connectURL}>
                        <img title='phantom web' className='wallet-logo' src="assets/img/phantom-wallet-logo.png" alt='phantom'/>
                        </link>)
                        :
                        (<button 
                          id='phantom-wallet' 
                          className='btn-sm btn-primary login-btn' 
                          onClick =  {async()=> 
                            {
                              const ac = await phantomLogin( );

                              if(ac){
                                const res2 = await fetch(props.blockchaininfos.baseAddr+'/api/setsession?network='+'solana-'+networks[network]+'&logtype='+PHANTOM+'&account='+ac+'&mode=1', { credentials:'include', redirect: 'manual'});
                                const blockchaininfos = await res2.json();
                                localStorage.removeItem('endpoint');
                                props.setBCInfos(blockchaininfos);
                              }
                              
                                //setupVerify(PHANTOM, 'solana-'+networks[network], ac)
                            }
                          }>
                          <img title='phantom web' className='wallet-logo' src="assets/img/phantom-wallet-logo.png" alt='phantom'/>
                        </button>
                        )
                      }
                    </div>
                    ):(<div></div>)
                  }
                
                  <button id='backpack-wallet' className='btn-sm btn-primary login-btn' onClick =  {async()=> 
                      {
                        const ac = await backpackLogin( );
                        if(ac){
                          const res2 = await fetch(props.blockchaininfos.baseAddr+'/api/setsession?network='+'solana-'+networks[network]+'&logtype='+BACKPACK+'&account='+ac+'&mode=1', { credentials:'include', redirect: 'manual'});
                          const blockchaininfos = await res2.json();

                          
                          localStorage.removeItem('endpoint');

                          props.setBCInfos(blockchaininfos);
                        }
                      }
                    }>
                    <img title='backpack web' className='wallet-logo' src="assets/img/backback-wallet-logo.jpeg" alt='phantom'/>
                  </button>
                </div>
              ):(
                <div className='col p-0 m-0'>
                  <button id='anchor-wallet' className='btn-sm btn-primary login-btn' onClick = { async()=>
                      {
                        const res = await fetch(props.blockchaininfos.baseAddr+'/api/setsession?network='+'wax-'+networks[network]+'&logtype=-1&account=&mode=1', { credentials:'include', redirect: 'manual'});
                        const config = await res.json() as BlockchainInfos;

                        resetwax();
                        const ac = await linkLogin(config.chainId, config.endpoints[0]);  
                        if(ac){

                          const res2 = await fetch(props.blockchaininfos.baseAddr+'/api/setsession?network='+'wax-'+networks[network]+'&logtype='+ANCHOR+'&account='+ac+'&mode=1', { credentials:'include', redirect: 'manual'});
                          const blockchaininfos = await res2.json();
                          localStorage.removeItem('endpoint');
                          props.setBCInfos(blockchaininfos);
                        }
                      }
                    }>
                    <img title='anchor' className='wallet-logo' src="assets/img/anchor-wallet.png" alt='phantom'/>
                  </button>
                  {network == 0 ?
                    (<button id='wax-wallet' className='btn-sm btn-primary login-btn' disabled = { network == 0 ? false:true} onClick = { async()=>
                        { 
                          const res = await fetch(props.blockchaininfos.baseAddr+'/api/setsession?network='+'wax-'+networks[network]+'&logtype=-1&account=&mode=1', { credentials:'include', redirect: 'manual'});
                          const config = await res.json() as BlockchainInfos;
                          const ac = await waxlogin(config.endpoints[0]);

                          if(ac){

                            const res2 = await fetch(props.blockchaininfos.baseAddr+'/api/setsession?network='+'wax-'+networks[network]+'&logtype='+WCW+'&account='+ac+'&mode=1', { credentials:'include', redirect: 'manual'});
                            const blockchaininfos = await res2.json();

                            localStorage.removeItem('endpoint');
                            props.setBCInfos(blockchaininfos);
                          }
                        }
                      }>
                      <img title='anchor' className='wallet-logo' src='assets/img/waxp.png' alt='phantom'/>
                    </button>)
                    :
                    (<span></span>)
                  }
                </div>)
            }
            </div>
          </div>
      )
    }

    export default NavBarWalletList;